import { DataSource } from '@angular/cdk/collections';
import { Package } from '../../../models/package';
import { Observable } from 'rxjs';

export class PackagesData implements DataSource<Package> {
    constructor(private source$: Observable<Package[]>) {
    }

    connect(collectionViewer: any): Observable<Package[]> {
        return this.source$;
    }

    disconnect(collectionViewer: any): void {
    }
}
